"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatbotService = void 0;
const i0 = require("@angular/core");
class ChatbotService {
    constructor() {
        this.cspireChatbotUtil = 'cspireChatbotUtil';
        this.MMA_SIGN_OUT = 'MMA_Sign_Out';
    }
    /**
     * Re-initialize chatbot
     */
    reInitializeChatbot(key) {
        this.chatbotUtil = window[this.cspireChatbotUtil];
        if (this.chatbotUtil && (typeof this.chatbotUtil.reInitChat === 'function')) {
            try {
                // Re-initialize chatbot
                this.chatbotUtil.reInitChat(key);
            }
            catch (e) {
                // ignore...just move on
            }
        }
    }
    signOutAndReInitializeChatbot() {
        this.reInitializeChatbot(this.MMA_SIGN_OUT);
    }
}
exports.ChatbotService = ChatbotService;
ChatbotService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ChatbotService_Factory() { return new ChatbotService(); }, token: ChatbotService, providedIn: "root" });
//# sourceMappingURL=chatbot.service.js.map